import axios from 'axios';
import * as endpoints from '../endpoints';
import { constants } from '../constants';

const baseUrl = constants.baseURL;

export const createInvoiceRequest = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.InvoiceRequest.BASE,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

export const createExpenseRequest = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.ExpenseRequest.BASE,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

export const createSupportTicket = async (data) => {
  return axios({
    method: 'post',
    url: endpoints.SupportTicket.BASE,
    baseURL: baseUrl,
    data: data,
  }).then((response) => response.data.result);
};

// The backend scopes these by role: admins get every request, everyone else
// only their own, so the same call serves both cases.
export const getInvoiceRequests = async () => {
  return axios({
    method: 'get',
    url: endpoints.InvoiceRequest.BASE,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

export const getExpenseRequests = async () => {
  return axios({
    method: 'get',
    url: endpoints.ExpenseRequest.BASE,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

export const getSupportTickets = async () => {
  return axios({
    method: 'get',
    url: endpoints.SupportTicket.BASE,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

export const getInvoiceRequestById = async (id) => {
  return axios({
    method: 'get',
    url: `${endpoints.InvoiceRequest.BASE}/${id}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

export const getExpenseRequestById = async (id) => {
  return axios({
    method: 'get',
    url: `${endpoints.ExpenseRequest.BASE}/${id}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

export const getSupportTicketById = async (id) => {
  return axios({
    method: 'get',
    url: `${endpoints.SupportTicket.BASE}/${id}`,
    baseURL: baseUrl,
  }).then((response) => response.data.result);
};

